import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8.497 2.037a.5.5 0 1 0-1 0v7.457L5.354 7.35a.5.5 0 1 0-.708.707l2.968 2.968c.09.106.221.175.37.179a.499.499 0 0 0 .37-.147l3-3a.5.5 0 0 0-.708-.707L8.497 9.5V2.036Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14 7.537a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8.04a.5.5 0 1 1 1 0v5.497h11v-5.5a.5.5 0 0 1 .5-.5Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }